module.exports = __webpack_public_path__ + "media/images/bottom_hf_scheme-798d1e53b7852356358d79faaa5a5139.png";